import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import RouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import CustomerUserStore from '../../../../store/CustomerUserStore';
import { modelOf } from '../../../../prop-types';
import globalTranslations from '../../../../i18n/globalTranslations';
import UIStore from '../../../../store/UIStore';
import Balance from '../Balance';
import { formatDate } from '../../../../util/date';
import Paginator from '../../../common/Paginator';
import { escapeUrlForPaginatorTemplate } from '../../../../util/url';
import BalancePaymentHistory from '../../../../models/BalancePaymentHistory';

@observer
export class BalanceUserPaymentHistory extends Component {
  renderBalancePaymentHistory = (balancePaymentHistory) => (
    <ListGroup>
      {!this.props.uiStore.isSmallest && this.renderListGroupHeaders()}
      {balancePaymentHistory.data.map((payment, i) => (
        <ListGroupItem key={i}>
          <Row className="BalanceUserPaymentHistory__payment-details">
            <Col
              xs={12}
              sm={3}
              className="BalanceUserPaymentHistory__payment-details-payment-order"
            >
              {payment.orders_id}
            </Col>
            <Col
              xs={12}
              sm={3}
              className="BalanceUserPaymentHistory__payment-details-payment-balance"
            >
              {this.renderBalanceUserBalance(payment.amount_with_tax)}
            </Col>
            <Col
              xs={12}
              sm={3}
              className="BalanceUserPaymentHistory__payment-details-payment-users"
            >
              {this.renderUsersPaymentDetails(payment.users)}
            </Col>
            <Col
              xs={12}
              sm={3}
              className="BalanceUserPaymentHistoryList__payment-details-payment-date"
            >
              {formatDate(payment.date_purchased)}
            </Col>
          </Row>
        </ListGroupItem>
      ))}
    </ListGroup>
  );

  renderListGroupHeaders = () => (
    <ListGroupItem className="BalanceUserPaymentHistory__list-headers">
      <Row>
        <Col sm={3}>
          <FormattedMessage {...globalTranslations.orderNumber} />
        </Col>
        <Col sm={3}>
          <FormattedMessage {...globalTranslations.balanceUserPaymentTotal} />
        </Col>
        <Col sm={3}>
          <FormattedMessage {...globalTranslations.balanceUserNameTitle} />
        </Col>
        <Col sm={3}>
          <FormattedMessage
            {...globalTranslations.balanceUserPaymentHistoryOrderDate}
          />
        </Col>
      </Row>
    </ListGroupItem>
  );

  renderBalanceUserBalance = (balance) => <Balance amount={balance} />;

  renderUsersPaymentDetails = (users) =>
    users.map(
      (user, i) =>
        user && (
          <dl key={i}>
            <dt>{user.name}</dt>
            <dd>{user.amount_with_tax}</dd>
          </dl>
        )
    );

  getPaginator = () => {
    const { balancePaymentHistory, location } = this.props;

    const { last_page: lastPage, current_page: currentPage } =
      balancePaymentHistory;

    let searchTemplate;
    const regex = /page=(\d+?)(?=(&|$))/;
    const pageParameter = `page=:page`;

    if (location.search.charAt(0) !== '?') {
      searchTemplate = location.search + '?' + pageParameter;
    } else {
      searchTemplate = location.search.match(regex)
        ? location.search.replace(regex, pageParameter)
        : location.search + '&' + pageParameter;
    }
    const pathTemplate =
      escapeUrlForPaginatorTemplate(location.pathname) + searchTemplate;

    return (
      <div className="BalanceUserPaymentHistory__Paginator">
        <Paginator
          pathTemplate={pathTemplate}
          currentPage={currentPage}
          lastPage={lastPage}
          pagesToShow={5}
        />
      </div>
    );
  };

  render() {
    const { balancePaymentHistory } = this.props;

    if (
      !balancePaymentHistory ||
      !balancePaymentHistory.data ||
      !balancePaymentHistory.data.length
    ) {
      return (
        <FormattedMessage
          {...globalTranslations.balanceUserNoBalancePurchases}
        />
      );
    }

    return (
      <div className="BalanceUserPaymentHistory">
        {balancePaymentHistory &&
          this.renderBalancePaymentHistory(balancePaymentHistory)}
        {balancePaymentHistory && this.getPaginator()}
      </div>
    );
  }
}

BalanceUserPaymentHistory.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  location: RouterPropTypes.location.isRequired,
  balancePaymentHistory: modelOf(BalancePaymentHistory),
};

export default withRouter(
  inject('customerUserStore', 'uiStore')(BalanceUserPaymentHistory)
);
